export default __webpack_public_path__ + "static/media/Share.08e18a35.svg";